<template>
  <div class="root">
    <div class="wrapper">
      <div class="vertical-export">
        <div class="contents"></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
});
</script>

<style lang="scss" scoped>
.root {
  position: absolute; // NOTE: 100vhでスクロールされてしまう問題の暫定対応
  width: 100%;
  background-color: var(--color-background-normal);
  color: var(--color-text-normal);

  .wrapper {
    display: flex;
    justify-content: center;

    .vertical-export {
      width: 100%;
      height: 100vh;
      writing-mode: vertical-rl; // 右から左への縦書き
      line-break: anywhere; // すべての文字で折り返す

      .contents {
        display: flex;
        flex-direction: column;
        align-items: center;
        line-break: auto;
      }
    }
  }
}
</style>

<style lang="scss">
h1 {
  font-size: 1.8em;
  margin: 0 1em;
  height: 100%; // temporary style (Override by Puppeteer)
  color: var(--color-text-normal);
}

p {
  font-size: 1.2em;
  line-height: 3em;
  letter-spacing: 0.2em;
  margin: 0;
  min-width: 3em;
  height: 100%; // temporary style (Override by Puppeteer)
  color: var(--color-text-normal);
}

span {
  display: inline-block; // 改ページでルビが離れないようにする
}

ruby {
  rt {
    letter-spacing: initial;
  }
}
</style>
